import { render, staticRenderFns } from "./MultiSelectChip.vue?vue&type=template&id=20038b06&scoped=true"
import script from "./MultiSelectChip.vue?vue&type=script&lang=js"
export * from "./MultiSelectChip.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectChip.vue?vue&type=style&index=0&id=20038b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20038b06",
  null
  
)

export default component.exports